'use strict';

import GusService from "./gus-service";
import Validators from "../validators";

class ServiceReportForm {
    constructor() {
        this.form = '#service-report-create-form';
        this.nip = '#service_report_form_nip';
        this.companyName = '#service_report_form_companyName';
        this.companyCity = '#service_report_form_companyAddress_city';
        this.companyStreet = '#service_report_form_companyAddress_street';
        this.companyNumberBuilding = '#service_report_form_companyAddress_buildingNumber';
        this.companyNumberLocal = '#service_report_form_companyAddress_apartmentNumber';
        this.companyPostCode = '#service_report_form_companyAddress_postCode';
        this.companyPostCity = '#service_report_form_companyAddress_post';
        this.diffDeviceAddress = '#service_report_form_diffInstallationAddress';
        this.deviceCity = '#service_report_form_deviceAddress_city';
        this.deviceStreet = '#service_report_form_deviceAddress_street';
        this.deviceNumberBuilding = '#service_report_form_deviceAddress_buildingNumber';
        this.deviceNumberLocal = '#service_report_form_deviceAddress_apartmentNumber';
        this.devicePostCode = '#service_report_form_deviceAddress_postCode';
        this.devicePostCity = '#service_report_form_deviceAddress_post';
        this.deviceProvince = '#service_report_form_deviceProvince';
        this.submitButton = '#service_report_form_submit';
        this.modalAcceptRulesButton = '#modal-accept-rules-button';

        this.onLoad();
        this.setUpListeners();
    }

    onLoad() {
        if (this.nipIsEmpty()) {
            this.disableDifferentDeviceAddressCheckbox();
        } else if (this.isInstallationAddressTheSame()) {
            this.disableOrEnableDeviceAddress();
        }
    }

    setUpListeners() {
        $(document).on('change', this.diffDeviceAddress, () => {
            this.disableOrEnableDeviceAddress();
        });
        $(document).on('change', this.nip, () => {
            let nipValue = $(this.nip).val();
            if (Validators.nip(nipValue)) {
                this.getDataFromGusAjax();
            } else {
                this.disableDifferentDeviceAddressCheckbox();
            }
        });

        $("#service_report_form_files_file").change(() => {
            this.showImages();
        });


        $(document).on('click', this.submitButton, () => {
            event.preventDefault();
        });

        $(document).on('click', this.modalAcceptRulesButton, () => {
            $(this.form).submit();
            $('#modal').modal('toggle');
        });
    }

    getDataFromGusAjax() {
        let self = this;
        let url = $(this.nip).data('gusurl');
        GusService
            .getDataByNip(url, $(self.nip).val())
            .done(function (data) {
                self.setDataFromGusApi(data);
                $(self.diffDeviceAddress).prop('disabled', false);
            })
            .fail(function () {
                self.disableDifferentDeviceAddressCheckbox();
            });
    }

    disableOrEnableDeviceAddress() {
        let disabledValue = this.isInstallationAddressTheSame();
        $(this.deviceCity).prop('disabled', disabledValue);
        $(this.deviceStreet).prop('disabled', disabledValue);
        $(this.deviceNumberBuilding).prop('disabled', disabledValue);
        $(this.deviceNumberLocal).prop('disabled', disabledValue);
        $(this.devicePostCode).prop('disabled', disabledValue);
        $(this.devicePostCity).prop('disabled', disabledValue);
        $(this.deviceProvince).prop('disabled', disabledValue);
    }

    isInstallationAddressTheSame() {
        return !$(this.diffDeviceAddress).is(':checked');
    }

    setDataFromGusApi(data) {
        $(this.companyName).val(data.companyName).prop('readonly', true);
        $(this.companyCity).val(data.companyCity).prop('readonly', true);
        $(this.companyStreet).val(data.companyStreet).prop('readonly', true);
        $(this.companyNumberBuilding).val(data.companyNumberBuilding).prop('readonly', true);
        $(this.companyNumberLocal).val(data.companyNumberLocal).prop('readonly', true);
        $(this.companyPostCode).val(data.companyPostCode).prop('readonly', true);
        $(this.companyPostCity).val(data.companyPostCity).prop('readonly', true);
    };

    disableDifferentDeviceAddressCheckbox() {
        $(this.diffDeviceAddress)
            .prop('disabled', true)
            .prop('checked', false);
        this.disableOrEnableDeviceAddress();
    }

    nipIsEmpty() {
        return $('#service_report_form_nip').val() === '';
    }

    removeImagesWrapper() {
        $("#images-wrapper img").remove();
        $("#images-wrapper").empty();
    }

    getFilesQuantity() {
        return document.getElementById("service_report_form_files_file").files.length;
    }

    createAndAppendImage(url) {
        $('#images-wrapper').append("<div class='col-md-4 col-12 one_img'><div class='wrap'><img src='" + url + "' alt='img_glob'></div></div>");
    }

    showImages() {
        this.removeImagesWrapper();
        const validImageTypes = ["image/gif", "image/jpeg", "image/jpg", "image/png"];

        let filesQuantity = this.getFilesQuantity();

        for (let i = 0; i < filesQuantity; i++) {
            let type = event.target.files[i]["type"];
            if ($.inArray(type, validImageTypes) !== -1) {
                this.createAndAppendImage(URL.createObjectURL(event.target.files[i]));
            }
        }
    }
}

export default ServiceReportForm;



// WEBPACK FOOTER //
// ./assets/js/utils/service-report-form.js